import React, { FC } from 'react'
import { Check } from 'lucide-react'

import customImageComponent from '../../common/CustomImageComponent'
import { getUserFullName } from '../../../helpers/helpers'
import { cn } from '../../../lib/utils'

import { IUserInterface } from '../../../models/users/user.interface'
import { Skeleton } from '../../ui/skeleton'

export interface IUserExtendedWithSelected extends IUserInterface {
  selected?: boolean
}

interface SearchUsersProps {
  loading: boolean
  searchValue: string
  users: IUserExtendedWithSelected[]
  onToggleSelect: (value: IUserExtendedWithSelected) => void
}

export const SearchUsers: FC<SearchUsersProps> = ({
  loading,
  users,
  searchValue,
  onToggleSelect,
}) => {
  return (
    <div className="mt-4 flex flex-col">
      {loading ? (
        <div className="flex flex-col gap-4 py-1">
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="flex gap-3 items-center">
              <Skeleton className="rounded-full w-10 h-10" />
              <div className="flex-1 flex flex-col gap-1">
                <Skeleton className="w-1/3 h-6" />
                <Skeleton className="rounded-full w-1/2 h-4" />
              </div>
            </div>
          ))}
        </div>
      ) : !users?.[0] && (searchValue?.length || 0) < 3 ? (
        <p className="text-black/50 text-center">Enter at least 3 letters</p>
      ) : users?.[0] ? (
        users?.map((user, index) => (
          <div
            key={index}
            onClick={() => onToggleSelect(user)}
            className="form-check mb-3 cursor-pointer"
          >
            <div className="user flex items-center rounded-lg py-1 w-full justify-between">
              <div className="min-w-fit flex items-center">
                {customImageComponent(
                  user.userProfilePicture,
                  getUserFullName(user) || user.userEmail,
                  'w-[40px] h-[40px] rounded-full border border-black/10 mr-2 avatarImg object-cover'
                )}
                <div className="hourseDetails w-10/12">
                  <div className="hourseTitle text-SeabiscuitDark200ThemeColor">
                    <p className="text-SeabiscuitDark200ThemeColor text-lg capitalize">
                      {getUserFullName(user)}
                    </p>
                    <p className="text-xs">{user?.userEmail}</p>
                  </div>
                </div>
              </div>
              {user.selected && (
                <div
                  className={cn(
                    'flex items-center justify-center w-5 h-5 rounded-full bg-black ',
                    !user.selected && 'hidden'
                  )}
                >
                  <Check className="w-3 h-3 text-white " />
                </div>
              )}
            </div>
          </div>
        ))
      ) : (
        <p className="text-black/50 text-center">No data found</p>
      )}
    </div>
  )
}
